import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Box, Grid } from '@mui/material';
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { Card, Loader, Toast } from "@egovernments/digit-ui-react-components";
import TakeActionItem from '../../../../../../../templates/Forms/TakeActionItem'
import useDepartmentSelector from "../../hooks/useDepartmentSelector";
import { FormInfo, MandatoryInfo, SubTab, SubTabs, SubTabsWrapper } from '../../forms/StyledComponents'
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import getOwnerRegistrationData from "./getRegistrationData";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import ReactToPrint from "react-to-print";

const OwnerRegistration = () => {
  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const { id } = useParams();
  const history = useHistory();
  const [isUdFlow] = useDepartmentSelector();
  const tenantId = Digit.ULBService.getStateId() || 'hp';
  const { info: userInfo } = Digit.UserService.getUser();
  const userUid = userInfo?.uuid;
  const { applicationData, isAppDataLoading } = getOwnerRegistrationData(id);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("OWNER_REGISTRATION_TAB") || 0);
  const [showToast, setShowToast] = useState(null);
  const componentRef = useRef();
  const Modal = useModal()
  const closeToast = () => {
    if (showToast.gotoProfile) {
      clearParams();
      sessionStorage.removeItem("currentTab");
      sessionStorage.removeItem("currentCity");
      sessionStorage.removeItem("currLocality");
      sessionStorage.removeItem("currVillage");
      setTimeout(() => {
        resetFormMTDocs()
      }, 0);
      history.push("/digit-ui/citizen/profile");
    }
    setShowToast(null)
  };

  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);

  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_OWNER_REGISTRATION", applicationData);
  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    }
    else if (key === "") {
      setParams({ ...data });
    }
    else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000)
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const showPreview = (val) => {
    handleTabChange(val);
    Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", val);
  };
  const approvedLayout = params?.approvedLayout === "no"
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId, 'OWNER_REGISTRATION');
  const handleTabChange = (nextTabNo, formData = null) => {
    if (formData) {
      const data = { ...params, ...formData }
      if ((activeTab === 0 && nextTabNo === 1) && !('applicationNo' in params)) {
        Digit.OBPSService.createOwner({ ownerRegistration: data }, tenantId)
          .then((res) => {
            const result = res.ownerRegistration?.[0];
            if (res?.ownerRegistration?.length > 0) {
              onSelect("", { ...formData, ...result }, true);
              Modal(
                "Application created.",
                `Application Created Successfully!`,
                "success"
              );
              setActiveTab(nextTabNo);
              sessionStorage.setItem("currentTab", nextTabNo);
              Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", nextTabNo)
            }
          })
          .catch((e) => {
            setShowToast({ error: true, message: e?.response?.data?.Errors[0]?.message });
          });
      } else {
        try {
          if (activeTab === 3) {
            data.workflow = approvedLayout ? { action: "FORWARD_TO_EXECUTIVE_ENGINEER", assignes: null } : { action: "FORWARD_TO_EMO", assignes: null }
          }
          else {
            data.workflow = { action: "UPLOAD_DOC", assignes: [userUid] };
          }

          console.log('updateApiCall before', data)
          updateApiCall.mutate({ ownerRegistration: data }, {
            onSuccess: () => {
              onSelect("", data);
              if (activeTab === 3) {
                Modal(
                  "Application submitted.",
                  `Application <strong>${data?.applicationNo}</strong> Submitted Successfully!`,
                  "success",
                  "/digit-ui/citizen/profile"
                );
              } else {
                Modal(
                  "Application updated.",
                  `Application Updated Successfully!`,
                  "success",
                );
              }
              setActiveTab(nextTabNo);
              sessionStorage.setItem("currentTab", nextTabNo);
              Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", nextTabNo)
            },
            onError: () => {
              setShowToast({ error: true, message: `Something went wrong, please try again!` });
            },
          })
          /*
          setActiveTab(nextTabNo);
          */
        } catch (error) {
          console.error(e);
          setShowToast({ error: true, message: `Something went wrong, please try again!` });
        }
      }
    } else {
      setActiveTab(nextTabNo);
      sessionStorage.setItem("currentTab", nextTabNo);
      Digit.SessionStorage.set("OWNER_REGISTRATION_TAB", nextTabNo)
    }
  };

  if (isAppDataLoading || !applicationData) {
    return <Loader />
  } 
  if(id) {
    if (!params?.landAreaDetails?.locality?.name) {
      return <Loader />
    }
  }

  return (
    <React.Fragment>
        {/* <Box className="container1" sx={{ my: 0 }}>
          {activeTab === 0 && (
            <FormInfo style={{ backgroundColor: '#d2eaf8' }}>
              Form of application for Permission under sub-section (2) of section 15-A or clause (a) of
              section 16 or sub-section (1) of section 30 or section 30-A (beyond the limits as specified
              under section 30-A) of the Uttar Pradesh Town and Country Planning Act, 1977 (Act No.
              12 of 1977) for Development of Land/Construction of Building.
              <br /><br />
              Mobile tower application is used to taking permission for installing the Mobile tower in the
              premises of TCP, SADA and UD departments.
            </FormInfo>
          )}

          <div className="formContainer">
            <Box className="formContainer" sx={{ my: '1rem !important', backgroundColor: '#e6eff8' }}>
              <div className="formInputContainer">
                <Grid container spacing={2}>
                  <Grid item xs={6} md={3}>{t(`BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL`)}</Grid>
                  <Grid item xs={6} md={3}><strong>{t('Mobile Tower Application')}</strong></Grid>
                  <Grid item xs={6} md={3}>{t(`Name`)}</Grid>
                  <Grid item xs={6} md={3}><strong>{userInfo?.name}</strong></Grid>
                  <Grid item xs={6} md={3}>{t("Mobile No.")}</Grid>
                  <Grid item xs={6} md={3}><strong>{userInfo?.mobileNumber}</strong></Grid>
                  <Grid item xs={6} md={3}>{t("Email")}</Grid>
                  <Grid item xs={6} md={3}><strong>{userInfo?.emailId}</strong></Grid>
                  <Grid item xs={6} md={3}>{t("Registration Number")}</Grid>
                  <Grid item xs={6} md={3}><strong>{userInfo?.registrationNumber || "N/A"}</strong></Grid>
                  <Grid item xs={6} md={3}>{t("City")}</Grid>
                  <Grid item xs={6} md={3}><strong>{userInfo?.permanentCity || "N/A"}</strong></Grid>
                </Grid>
              </div>
            </Box>
          </div>
        </Box> */}

      <SubTabsWrapper>
        <Box className="container1">
          <SubTabs
            value={activeTab}
            onChange={(e, i) => handleTabChange(i)}
            indicatorColor="#1F4A7C"
            aria-label="sub tabs"
          >
            <SubTab label={t("LABEL_APPLICANT_INFO")} />
            <SubTab label={t("Map Information")} />
            <SubTab label={t("Documents")} />
            <SubTab label={t("LABEL_SUMMARY")} />
          </SubTabs>
          <MandatoryInfo>(<span>*</span>) Indicates Mandatory Field</MandatoryInfo>
        </Box>
      </SubTabsWrapper>

      {activeTab === 0 && (
        <Step1
          formData={params}
          isUpdating={updateApiCall.isLoading}
          handleTabChange={handleTabChange}
        />
      )}
      {activeTab === 1 && (
        <Step2
          formData={params}
          isUpdating={updateApiCall.isLoading}
          handleTabChange={handleTabChange}
        />
      )}
      {activeTab === 2 && (
        <Step3
          formData={params}
          isUpdating={updateApiCall.isLoading}
          handleTabChange={handleTabChange}
        />
      )}
      {activeTab === 3 && params?.applicationNo && (
        <div>
          <ReactToPrint
              trigger={() => <button   
                style={{
                backgroundColor: '#1f4a7c',
                color: '#fff',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                cursor: 'pointer',
                position: 'absolute',
                right: '2rem'
              }}>Print Summary</button>}
              content={() => componentRef.current}
            />
          <Card style={{ width: '90%', margin: '0 auto' }} ref={componentRef}>
            <TakeActionItem
              formType={'OWNER_REGISTRATION'}
              id={params?.applicationNo}
              ref={componentRef}
            />
          </Card>
          <div className="footerContainer">
            <div className="buttonWrapper">
            <Button variant="contained" onClick={() => { showPreview(0) }} style={{ backgroundColor: '#2e7d32', color: '#fff', marginTop: '1rem', justifyContent: 'center'}}>
                Preview
              </Button>
              <Button color="primary" onClick={() => { handleTabChange(3, params) }} style={{ display: 'flex', alignItems: 'center', backgroundColor: '#2e7d32', color: '#fff', marginTop: '1rem', justifyContent: 'center' }}>
                {`Forward to Department`}
              </Button>
            </div>
          </div>
        </div>
      )}
      {
        showToast && (
          <Toast
            error={showToast?.error}
            warning={showToast?.warning}
            label={t(showToast?.message)}
            onClose={closeToast}
            isDleteBtn={true}
          />
        )
      }
    </React.Fragment>
  );
};

export default OwnerRegistration;
